import { RouterProvider } from "react-router-dom";
import { ToastProvider, ErrorBoundary } from "@aiskills/ui-kit";
import { router } from "./router";

export function App() {
  return (
    <ErrorBoundary
      fallback={(err, reset) => (
        <div role="alert" className="aiskills-auth-shell">
          <div className="aiskills-auth-shell__card">
            <h1 className="aiskills-auth-shell__title">Something went wrong</h1>
            <p className="aiskills-auth-shell__subtitle">{err.message}</p>
            <button type="button" className="aiskills-btn aiskills-btn--primary aiskills-btn--md" onClick={reset}>
              <span className="aiskills-btn__label">Retry</span>
            </button>
          </div>
        </div>
      )}
    >
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </ErrorBoundary>
  );
}
